(() => {
  // Helper function for title case with special character handling
  function toTitleCase(str) {
    return str
      .toLowerCase()
      .split(' ')
      .map(word => {
        // Handle words with / in them
        if (word.includes('/')) {
          return word.split('/').map(part => {
            if (part.includes('-')) {
              return part.split('-').map(p => 
                p.charAt(0).toUpperCase() + p.slice(1)
              ).join('-');
            }
            return part.charAt(0).toUpperCase() + part.slice(1);
          }).join('/');
        }
        // Handle words with - in them
        if (word.includes('-')) {
          return word.split('-').map(part => 
            part.charAt(0).toUpperCase() + part.slice(1)
          ).join('-');
        }
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }

  // Format filter text based on filter type
  function formatFilterText(container) {
    container.querySelectorAll('.jsFilterUpdate').forEach((section) => {
      const filterId = section.dataset.filterId;
      section.querySelectorAll('.filter-section-list .text').forEach((el) => {
        if (filterId === 'brand') {
          el.textContent = toTitleCase(el.textContent);
        } else {
          el.textContent = el.textContent.toUpperCase();
        }
      });
    });
    // Prevent background scroll when scrolling filter list on mobile
document.querySelectorAll('.filter-section-list').forEach(list => {
  list.addEventListener('touchstart', function(e) {
    this.startY = e.touches[0].clientY;
  }, { passive: true });
  
  list.addEventListener('touchmove', function(e) {
    const scrollTop = this.scrollTop;
    const scrollHeight = this.scrollHeight;
    const height = this.clientHeight;
    const deltaY = this.startY - e.touches[0].clientY;
    
    // At top and scrolling up, or at bottom and scrolling down
    if ((scrollTop === 0 && deltaY < 0) || 
        (scrollTop + height >= scrollHeight && deltaY > 0)) {
      e.preventDefault();
    }
  }, { passive: false });
});
  }

  // Hide filter options with count of 0
  function hideZeroCountFilters(container) {
    container.querySelectorAll('.jsFilterUpdate').forEach((section) => {
      let visibleCount = 0;
      
      // Get the filter name from the accordion label
      const accordion = section.closest('accordion-component');
      const filterName = accordion?.querySelector('.label')?.textContent?.trim() || 'filter';
      
      section.querySelectorAll('li').forEach((li) => {
        const count = li.querySelector('[data-count]');
        if (count && count.dataset.count === '0') {
          li.classList.add('filter-hidden');
          li.classList.remove('none');
        } else {
          li.classList.remove('filter-hidden');
          li.classList.remove('none');
          visibleCount++;
        }
      });
      
      // Remove existing no results message
      const existingMsg = section.querySelector('.filter-no-results');
      if (existingMsg) {
        existingMsg.remove();
      }
      
      // Add no results message if all items are hidden
      const filterList = section.querySelector('.filter-section-list');
      if (visibleCount === 0 && filterList) {
        const noResults = document.createElement('div');
        noResults.className = 'filter-no-results';
        noResults.textContent = `No ${filterName.toLowerCase()} options available for current selection`;
        filterList.after(noResults);
      }
      
      const showMoreBtn = section.querySelector('.jsFilterShowMore');
      if (showMoreBtn) {
        showMoreBtn.style.display = 'none';
      }
    });
  }

  var { debounceTime, addEvent } = theme;
  customElements.define("filter-component", class extends HTMLElement {
    constructor() {
      super();
      this.container = this.closest("[data-section-id]");
      this.cache = [];
      this.andLogic = JSON.parse(this.dataset.andLogic || "false");
      this.filterType = this.dataset.type || "attribute";
      this.form = null;
      this.inputClass = null;
    }
    connectedCallback() {
      const formInput = this.querySelector("input[form]");
      this.form = formInput ? document.getElementById(formInput.getAttribute("form")) : this.querySelector("form");
      this.inputClass = `input[form="${this.form?.id}"]`;
      this.addEvents();
    }
    addEvents() {
      this.addEventListener("change", ({ target }) => {
        let selectedTarget = target;
        if (selectedTarget.name == "sortBy") {
          const sortEl = [...this.querySelectorAll("[name=sort_by]")].find((item) => item.value == selectedTarget.value);
          sortEl.checked = true;
          selectedTarget = sortEl;
        }
        this.onChange(selectedTarget);
      });
      this.form.addEventListener("submit", (e) => {
        e.preventDefault();
        this.submit();
      });
      this.querySelector(".jsFilterReset")?.addEventListener("click", (e) => {
        e.preventDefault();
        this.uncheckInput();
        this.submit();
      });
      // On mobile, scroll to show filtered results
      if (window.innerWidth < 992) {
        const productContainer = this.querySelector("#" + this.dataset.product);
        if (productContainer) {
          setTimeout(() => {
            productContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        }
      }
      this.removeFilter();
      this.filterSearch();
    }
    onChange(target) {
      const input = target;
      !this.andLogic && this.uncheckInput(input);
      document.querySelectorAll(`.filter-input[id='${input.id}']`).forEach((cb) => {
        cb.checked = input.checked;
      });
      if (target.hasAttribute("auto-submit"))
        this.submit();
    }
    uncheckInput(input = null) {
      let inputList;
      if (input) {
        inputList = this.querySelectorAll(`input[name="${input.name}"][form="${this.form.id}"]:not([id="${input.id}"])`);
      } else {
        inputList = this.querySelectorAll(`input[form="${this.form.id}"]`);
      }
      inputList.forEach((i) => {
        i.removeAttribute("checked");
        i.checked = false;
      });
    }
    get getQueryString() {
      const formData = new FormData(this.form);
      const query = new URLSearchParams(formData);
      if (this.filterType == "attribute")
        return query.toString();
      const queryString = query.toString();
      const arrayFilter = [];
      let sort = "";
      queryString.split("&").map((i) => {
        !i.includes("sort_by=") ? arrayFilter.push(i.split("=")[1]) : sort = i;
      });
      return arrayFilter.join("+") + (sort.length ? `?${sort}` : "");
    }
    submit() {
      const query = this.getQueryString;
      const findInCache = this.cache.find((i) => i.query == query);
      if (findInCache) {
        this.render(findInCache.DOM, findInCache.query);
        return;
      }
      let url = this.form.action;
      url += this.filterType == "attribute" ? "?" : "/";
      url += query;
      url += this.filterType == "attribute" || query.includes("?") ? "&" : "?";
      url += `section_id=${this.dataset.sectionId}`;
      fetch(url).then((e) => e.text()).then((html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        this.cache.push({
          query,
          DOM: div
        });
        this.render(div, query);
      });
    }
    render(result, searchParams = null) {
      if (searchParams) {
        let splitCharacter = this.filterType == "attribute" ? "?" : !searchParams.includes("?") || searchParams.includes("?") && searchParams.split("?")[0].length ? "/" : "";
        history.pushState({ searchParams }, "", `${this.form.action}${searchParams && splitCharacter.concat(searchParams)}`);
      }
      this.querySelectorAll(this.inputClass).forEach((input, i) => {
        if (!input.id)
          return;
        input.checked = result.querySelector(`#${input.id}`)?.checked || false;
      });
      this.querySelector("#" + this.dataset.product).innerHTML = result.querySelector("#" + this.dataset.product).innerHTML;
      this.querySelectorAll(".jsFilterUpdate")?.forEach((item) => {
        let newItem;
        if (item.dataset.filterId) {
          newItem = result.querySelector(`[data-filter-id="${item.dataset.filterId}"]`);
        } else {
          newItem = result.querySelector(`[class="${item.className}"]`);
        }
        if (!newItem)
          return;
        item.innerHTML = newItem.innerHTML;
      });

      // Apply formatting
      hideZeroCountFilters(this);
      formatFilterText(this);

      this.removeFilter();
    }
    removeFilter() {
      this.querySelectorAll(".jsFilterRemove")?.forEach((item) => {
        item.addEventListener("click", (event) => {
          event.preventDefault();
          const value = item.querySelector(".jsValue").textContent;
          this.querySelectorAll(`input[form="${this.form.id}"]`).forEach((item2) => {
            if (item2.value != value)
              return;
            item2.checked = false;
          });
          this.submit();
        });
      });
    }
    filterSearch() {
      this.querySelectorAll(".jsFilterSearch")?.forEach((item) => {
        const parentEl = item.closest(".filter-block, .filter-section-wrapper");
        item.addEventListener("click", (e) => {
          e.preventDefault();
          const value = item.previousElementSibling.value;
          searchFilterValue(parentEl, value);
        });
        item.previousElementSibling.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.keyCode === 13) {
            e.preventDefault();
            const value = e.target.value;
            searchFilterValue(parentEl, value);
            return;
          }
        });
        item.previousElementSibling.addEventListener("keyup", (e) => {
          if (e.key === "Enter" || e.keyCode === 13) return;
          (e.keyCode == 8 || !item.previousElementSibling.value.length) && clearField(parentEl);
          const value = item.previousElementSibling.value;
          searchFilterValue(parentEl, value);
        });
      });
      const clearField = (el) => {
        el.querySelectorAll("li.matched")?.forEach((item) => item.classList.remove("matched"));
      };
      const searchFilterValue = (container, value) => {
        const filterListItem = container.querySelectorAll("[name*=filter]");
        if (value.length) {
          container.classList.add("searching");
          const normalizedSearch = value.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
          filterListItem.forEach((item) => {
            const normalizedValue = item.value.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
            const parentEl = item.closest("li");
            parentEl.classList.toggle("matched", normalizedValue.includes(normalizedSearch));
          });
        } else {
          container.classList.remove("searching");
          container.querySelectorAll(".matched")?.forEach((item) => item.classList.remove("matched"));
        }
        container.querySelector(".jsFilterShowMore")?.classList.toggle("none", value.length);
      };
    }
  });

  // Show More button handler
  document.querySelectorAll('.jsFilterShowMore').forEach(btn => {
    btn.addEventListener('click', function() {
      const container = this.closest('.filter-block, .filter-section-wrapper');
      const filterList = container.querySelectorAll('.jsFilterToggle.none');
      filterList.forEach((item, index) => {
        if (index < 10) item.classList.remove('none');
      });
      const hiddenFilterCount = container.querySelectorAll('.jsFilterToggle.none').length;
      if (!hiddenFilterCount) this.classList.add('none');
      this.querySelector('.attr-count').setAttribute('data-count', Math.min(10, hiddenFilterCount));
    });
  });

  // Apply formatting on page load
  formatFilterText(document);
  hideZeroCountFilters(document);

})();